
import { Component, ViewChild, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatagridService } from 'src/app/services/datagrid.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { GetTypePipe } from 'src/app/custom-pipe/GetTypePipe';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { AppConfigService } from 'src/app/app-config.service.service';

import { DxDataGridModule, DxButtonModule, DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { WavesModule, SelectModule, ToastService } from 'ng-uikit-pro-standard';


@Component({
  selector: 'app-shared-datagrid',
  templateUrl: './shared-datagrid.component.html',
  styleUrls: ['./shared-datagrid.component.scss']
})
export class SharedDatagridComponent implements AfterViewInit {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @Output() messageEvent = new EventEmitter<string>();
  @Output() onLoadData = new EventEmitter<any>();

  @Input() filters: any;
  @Input() offsetHeight: any;

  //grid
  dataSource: { ID: number, projectID: number, projectName: string, customerName: string, category: string, status: string, bidDate: string, bidTime: string, projectSalesPerson: string, amountPor: string, productSpecified: string, customerSalesPerson: string, engineer: string }[];

  customer: any;
  now: any;
  popupNewProject: any;
  clearFilter: any;
  get: any;
  optionsCType: any;
  reportData: any;
  reportColumns: any;
  component: any;
  dataSource2: any;
  grouppanel: boolean = false;
  exportexcel: boolean = false;
  headfilter: boolean = true;
  filterrow: boolean = true;
  filterpanel: boolean = true;
  moduleTitle: string = '';
  popupDelete: boolean = false;
  filter: any;
  customOperations: Array<any>;
  filterValue: Array<any>;
  moduleId: string;

  currentModuleId: number;
  filterValueSaved: any;


  iId: number = 0;

  public activeLang = 'en';
  dateFormat = 'dd-MM-yyyy';
  moneyFormat = '';
  lines: any = [];

  pageOpen: number = 1;

  constructor(private datagridService: DatagridService, private activatedRoute: ActivatedRoute, private translate: TranslateService, private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe, private translateService: TranslateService, private appConfigService: AppConfigService, private router: Router, private toast: ToastService) {


    this.component = { data: [], columns: [] };


  }

  ngAfterViewInit(): void {

    this.setInfo2();
  }

  goLink(rowData, router, activeRoute, routeLink) {
    // console.log('Mira lo que viene');
    // console.log(rowData);
    // console.log(activeRoute);
    // console.log(routeLink);
    router.navigate([routeLink], { queryParams: rowData });
  }

  showDeleteModal(theThis, info) {
    theThis.popupDelete = true;
    theThis.iId = info.numiId;
  }

  contentReady (e) {


    if (this.currentModuleId){

      if (e.component.option("filterValue")){


        this.filterValueSaved = { moduleid: this.currentModuleId, filters: e.component.option("filterValue")}
        localStorage.setItem('filterValueSaved' + this.currentModuleId, JSON.stringify(this.filterValueSaved));
      }
      else{
        if (this.pageOpen > 4){


          localStorage.removeItem('filterValueSaved' + this.currentModuleId);
          this.pageOpen = 4;
        }
      }
    }

    this.pageOpen = this.pageOpen + 1;

  }

  deleteObject() {
    this.datagridService.CallDeleteGrid(this.iId, this.currentModuleId).subscribe(result => {
      this.setInfo2();
      this.popupDelete = false;
      this.toast.success(this.translate.instant('msgObjDelSucc'));
    });
  }

  exportGrid() {
    const doc = new jsPDF();
    exportDataGridToPdf({
      jsPDFDocument: doc,
      component: this.dataGrid.instance
    }).then(() => {
      doc.save('report.pdf');
    })
  }

  setInfo2() {
    this.translate.setDefaultLang(this.activeLang);

    this.dateFormat = this.appConfigService.dateFormat;
    this.moneyFormat = this.appConfigService.moneyFormat;

    let configGrid: any;

    this.moduleId = sessionStorage.getItem('moduleId');

    let objData: any = {};

    const queryParamEntries = this.activatedRoute.snapshot.queryParamMap.keys.map(key => [key, this.activatedRoute.snapshot.queryParamMap.get(key)])

    if (this.filters) {

      objData = this.filters;
      if (!(this.filters.moduleid)) {

        objData.moduleid = parseInt(this.moduleId);
      }
    }
    else {

      objData.moduleid = parseInt(this.moduleId);
    }

    if (queryParamEntries.length > 0) {
      var arrObj = queryParamEntries.reduce(function (o, currentArray) {
        var key = currentArray[0], value = currentArray[1]
        o[key] = value
        return o
      }, {})
      objData = { ...objData, ...arrObj }
    }



    // if (objData.moduleid == -4) {
    //   let json = '{"moduleid":-4,"numiId":"6470","numnumProjectID":"6470","numProjectID":"6470","strProjectNumber":"02052021-SIN PIPELINE","strProjectNumberSolo":"02052021","curDOLLARAMOUNT":"0","datSTRBIDREQUESTDATE":"2021-02-05T00:00:00","numBIDSTATUS":"1","strCONTRACTORNAMEP":"DEmo Jeff","strCONTACTNAME":"UNKNOWN ","strPROJECTSLSCATEGORY":"P&SC","strBIDSTATUSDESCRIPTION":"PB","ico_Sold":"fas  fa-exclamation-circle whiteiconcolor/ ","numISOPORT":"1","datBIDREQUESTDATE":"2021-02-05T00:00:00","numPROJECTID1":"6470","numPROFFITMARGIN":"0","numDESIGNERID":"0","numSALESEMPLOYEE":"0","numCONTRACTORBUYER":"0","numPROJECTVERTICALID":"1","numCUSTOMERREQPRICEID":"0","numNOTBIDREASON":"0","strSALESCOMMENTS":"","booPREVAILINGWAGES":"false","numtotalCount":"5865","datBIDDATE":"2021-02-05T00:00:00","numSALESCATEGORYID":"1","numAWARDEDTO":"0","strDESIGNERNAME":"DEmo Jeff","strBUYERNAME":"DEmo Jeff","strCUSREQPRICENAME":"DEmo Jeff","numIsPipeline":"1","numPIPELINEID":"332"}';
    //   objData = JSON.parse(json);
    // }


    this.currentModuleId = objData.moduleid;
    // console.log(objData)
    if(objData != undefined){
      if(isNaN(objData.moduleid)){
        this.router.navigateByUrl('/login');
      } else {
        this.datagridService.CallGrid(objData).subscribe(result => {

          // This timeout in temp. Next routines generate error when http call is fast. The error was not fixed yet and this timeout is only
          // for testing

          setTimeout(() => {

            this.reportData = result.data;

            configGrid = JSON.parse(result.config);

            // It is an option to use shared datagrid in two modules User / Dashboard Component
            if (objData.hasOwnProperty("isBI")) {
              if (objData.isBI == 1) {
                configGrid.Second_Level = "adminComponent/editAdminComponentbi";
              }
            }

            this.component.data = this.reportData;

            let columns = [];
            let names = configGrid.Fields.map(x => x.name);
            // let names = Object.keys(this.component.data[0]);

            let columnIndex = 0;
            let columnIndexGroup = undefined;

            let filterConfig = configGrid.Filters;

            let mythis = this;

            this.grouppanel = configGrid.ShowGroupPanel;
            this.exportexcel = configGrid.ShowExportExcel;

            this.filterpanel = configGrid.ShowFilterPanel;

            this.filterrow = configGrid.ShowFilterRow;
            this.headfilter = configGrid.ShowHeadFilter;

            this.messageEvent.emit(configGrid.ModuleName)

            names.forEach(element => {
              if (element == configGrid.Group_Name) {
                columnIndexGroup = columnIndex;
              }
              columnIndex = columnIndex + 1;

              let strFieldType = 'string';
              let format = '';

              if (element.substring(0, 3) == 'dat') {
                strFieldType = 'date';
                format = mythis.dateFormat;
              }
              else if (element.substring(0, 3) == 'boo') {
                strFieldType = 'boolean';
              }
              else if (element.substring(0, 3) == 'cur') {
                strFieldType = 'number';
              }
              else if (element.substring(0, 3) == 'num') {
                strFieldType = 'number';
              }
              else {
                strFieldType = 'string';
              }

              let columnWidth: string = '';


              configGrid.Fields.forEach(field => {
                if (field.name == element) {
                  columnWidth = field.width;
                }
              })

              if (columnWidth != '') {

                let traduction: any = this.translateService.get(element);

                let objColumn: any = {
                  dataField: element,
                  width: columnWidth,
                  caption: traduction.value.replace('ico_', ''),
                  dataType: strFieldType,
                  cellTemplate: function (element, info) {
                    element.append("<div>" + info.text + "</div>")

                    let html = '';
                    html = "<div>" + info.text + "</div>"

                    // let initial = names[info.columnIndex].substr(0, 3);
                    let initial = info.column.dataField.substr(0, 3);
                    // let val = info.data[names[info.columnIndex]];
                    let val = info.values[info.columnIndex];


                    if (initial == 'hyp') {
                      html = '<div> <a href=' + val + ' target="_blank"><i class="fa fa-link"></i> View link</a></div>';
                    }

                    else if (initial == 'ico') {
                      if(val)
                        html = '<div><i class="' + val.split('/')[0] + '"></i>' + val.split('/')[1] + '</div>';
                    }

                    else if (initial == 'str' || initial == 'boo') {
                      val = val ? val : '';
                      html = '<div>' + val + '</div>';
                    }

                    else if (initial == 'cur') {
                      html = '<div>' + mythis.currencyPipe.transform(val, mythis.moneyFormat) + '</div>'
                    }

                    else if (initial == 'dat') {
                      if (val) {
                        html = '<div>' + mythis.datePipe.transform(val, mythis.dateFormat) + '</div>'
                      }
                    }

                    else {
                      html = '<div>' + val + '</div>';
                    }

                    element.innerHTML = html;

                  }
                }

                if (format) {

                  objColumn.format = format;
                }
                columns.push(objColumn);

              }

            });

            let handler = this.goLink;
            let handler2 = this.showDeleteModal;
            let therouter = this.router;
            let theactiverouter = this.activatedRoute;
            var theThis = this;

            // Add Edit Buttons if option is active
            if (configGrid.Edit == true) {
              let obj = {
                width: "3%",
                cellTemplate: function (el, info) {
                  let element = document.createElement("a");
                  element.innerHTML = '<a class=" mr-2" (click)="goEdit(data.data)">  <span style="font-size: 0.9rem;color:#0275d8 !important;" class="bg-green" data-toggle="tooltip"    title="Edit"><i class="fas fa-edit"></i></span>    </a>';
                  element.onclick = (e) => {
                    // call handler
                    handler(info.data, therouter, theactiverouter, configGrid.Second_Level);

                    // or execute click action here
                  };

                  el.append(element);
                }
              }

              columns.push(obj);

            }

            // Add Delete Buttons if option is active
            if (configGrid.Delete == true) {
              let obj = {
                width: "3%",
                cellTemplate: function (el, info) {
                  let element = document.createElement("a");
                  element.innerHTML = '<a class=" mr-2" (click)="showDeleteModal()">  <span style="font-size: 0.9rem;color:#0275d8 !important;" class="bg-green" data-toggle="tooltip"    title="Delete"><i class="fas fa-trash"></i></span>    </a>';
                  element.onclick = (e) => {
                    // call handler
                    theThis.showDeleteModal(theThis, info.data);

                    // or execute click action here
                  };

                  el.append(element);
                }
              }

              columns.push(obj);

            }

            this.component.columns = columns;
            setTimeout(() => {

              this.dataGrid.instance.clearGrouping();
              this.dataGrid.instance.columnOption(columnIndexGroup, "groupIndex", '0');

              var myArrayFilter = [];
              if (filterConfig) {
                // console.log(filterConfig);
                myArrayFilter = filterConfig;
              }

              if (myArrayFilter.length > 0) {

                if (filterConfig[0].length > 1){

                  this.filterValue = [];

                  this.filterValue.push(filterConfig);

                }

              }



              this.filterValueSaved = JSON.parse(localStorage.getItem('filterValueSaved' + this.currentModuleId));

              if (this.currentModuleId){
                if (this.filterValueSaved){

                  this.filterValue = [];
                  this.filterValue.push(this.filterValueSaved.filters);
                }
              }



            }, 1000);



            if (this.reportData){
              this.onLoadData.emit(this.reportData);
            }

         }, 1000);

        });
      }
    }

  }

}
